import type { Application } from '@src/@types/app';
import { CHANNELS } from '@src/constants/advertising';
import { FILTERS_NAMES } from '@src/constants/filters';
import { ListKeys } from '@src/constants/microcredits';
import { getUserPhoneForChecker } from '@src/helpers/getUserPhoneForChecker';
import { CookieKey } from '@src/modules/cookie';
import { fetchOffers } from '@src/reducers/microcredits';
import { getCookieFromServerOrClient } from '@src/utils/getCookieFromServerOrClient';

export const getFullDealAndPing3OffersPageData = async (ctx: Application.ReduxNextPageContext) => {
  const {
    store: { dispatch },
  } = ctx;

  const filterParams = getFilterParams(ctx);

  await dispatch(
    fetchOffers({
      query: ctx.query,
      params: filterParams,
      key: ListKeys.FULL_DEAL_AND_PING3_OFFERS,
    }),
  );
};

function getFilterParams(ctx: Application.ReduxNextPageContext) {
  const clientId = getCookieFromServerOrClient(ctx, CookieKey._ym_uid);

  return {
    [FILTERS_NAMES.LOCATION]: ctx.params.locationRoute,
    [FILTERS_NAMES.METADATA]: true,
    [FILTERS_NAMES.ROUTE]: { asPath: ctx.asPath ?? '', query: ctx.query ?? {} },
    [FILTERS_NAMES.HAS_OFFERS_DUPLICATE]: false,
    ...(Boolean(clientId) && {
      [FILTERS_NAMES.CLIENT_ID]: clientId,
    }),
    ...getUserPhoneForChecker(ctx),
    [FILTERS_NAMES.CHANNEL]: CHANNELS.FULL_DEAL,
    [FILTERS_NAMES.ADS_ONLY]: true,
  };
}
